import * as React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class SidebarOverlayPositionSvg extends React.PureComponent<InjectedSvgProps> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { className, fillColor } = this.props;

        return (
            <BaseSvg viewBox="0 0 24 24" className={className}>
                <path fill={fillColor} d="M14.5,3V21H3V3H14.5m3-3H0V24H17.5V0Z" />
                <rect fill={fillColor} x="17.59" y="0.5" width="5.91" height="23" />
                <path fill={fillColor} d="M23,1V23H18.09V1H23m1-1H17.09V24H24V0Z" />
                <polygon fill={fillColor} points="6.28 12.32 12.5 19.14 12.5 5.5 6.28 12.32" />
            </BaseSvg>
        );
    }
}
